import axiosInstance from '../config/axios.js';

const API_BASE = '/billing-payments';

const billingPaymentService = {
  // Get all billing payments with optional filters and pagination
  getAll: async (page = null, perPage = 10, params = {}) => {
    const queryParams = page !== null
      ? { page, per_page: perPage, ...params }
      : { all: 'true', ...params };
    const response = await axiosInstance.get(API_BASE, { params: queryParams });
    return response.data;
  },

  // Get all payments for a specific billing
  getByBillingId: async (billingId, page = null, perPage = 10, params = {}) => {
    const queryParams = page !== null
      ? { billing_pk: billingId, page, per_page: perPage, ...params }
      : { billing_pk: billingId, all: 'true', ...params };
    const response = await axiosInstance.get(API_BASE, { params: queryParams });
    return response.data;
  },

  // Get payment by ID
  getById: async (paymentId) => {
    const response = await axiosInstance.get(`${API_BASE}/${paymentId}`);
    return response.data;
  },

  // Create new payment record
  create: async (paymentData) => {
    const response = await axiosInstance.post(API_BASE, paymentData);
    return response.data;
  },

  // Update payment record
  update: async (paymentId, paymentData) => {
    const response = await axiosInstance.put(`${API_BASE}/${paymentId}`, paymentData);
    return response.data;
  },

  // Get all payments for a specific billing (using primary key)
  getByBilling: async (billingPk) => {
    const response = await axiosInstance.get(`${API_BASE}/billing/${billingPk}`);
    return response.data;
  },

  // Delete payment record
  delete: async (paymentId) => {
    const response = await axiosInstance.delete(`${API_BASE}/${paymentId}`);
    return response.data;
  },
};

export default billingPaymentService;